import { afterAddToBagPersonalizationTracking, addToBagPersonalizationTracking, getPersonalizationMergeParameter } from '../global/_personalization';
import { formValidation } from '../global/_formValidation';
import { updateHeaderShoppingBagCounts, quickConvert } from '../international/_intl';
import { slickRecs } from '../productRecs/_productRecs';
import { slickRecsATB } from '../productRecs/_productRecs';
import { qvClose_mt } from '../modals_2017/_quickview';
import { setCookieOrWebStorage } from '../global/_cookies';
import Cookies from 'js-cookie';


export const ajaxAddToBag = (params, returnHTML) => {
	var pos = $(document).scrollTop(),
		setTop = `-${pos}px`;

	function myCallback() {
		if ($('.qv-modal').length > 0) {
			if ($('#layoutCart').length > 0) setCookieOrWebStorage('sessionStorage', 'qvItemNum', $('.qv-item-num').text());
			$('.qv-modal').remove();
		} else if ($('.oss-modal').length > 0) $('.oss-modal').remove();
		$('#add-to-bag-list-contain').removeAttr('style');
		//Other callback js for ajaxAddToBag
		formValidation();
		if (
			($('.chanel-add-to-bag').length > 0 && $('#OHOOEmailInput').length > 0) ||
			($('.chanel-add-to-bag').length > 0 && $('.outOfStock').length > 0) ||
			($('.chanel-add-to-bag').length > 0 && $('.alert-info-LmtAv').length > 0)
		) {
			$('.modal-right').hide();
		}
		updateHeaderShoppingBagCounts();
		$('#addedToWishlist-alert, #addedToWishlist-error-alert, #addedToWishlist-lowqty-alert').fadeOut(3000);
		afterAddToBagPersonalizationTracking();
		$('#dynamicModalContainer').on('shown.bs.modal', function () {
			$('img.lazy-img').lazyload({
				threshold: 10000,
			});
			var slicking = setInterval(function () {
				if ($('#add-to-bag-rec .rec-list li img').length > 0 && $('#add-to-bag-rec .rec-list li').last().find('img').length > 0) {
					slickRecsATB($('#add-to-bag-rec .rec-list li'), $('#add-to-bag-rec .rec-list'));
					clearInterval(slicking);
				}
			}, 500);
			if ($('#OHOOEmail').length > 0 && $('.add-to-modal-image').length == 0) {
				$('.modal-title').hide();
			}
			if (($('.modal-title-ATB').length == 1 || $('.modal-title-ATB-GiftCard').length == 1) && $('.chanel-add-to-bag').length == 0) {
				$('.close').hide();
				$('.modal-title').hide();
				$('.modal-body').addClass('modal-body-ATB');
			}
			if ($('.closeATB').length == 1 && $('.chanel-add-to-bag').length == 0) {
				$('.modal-header').hide();
				$('.close').hide();
			}
		});
	}

	function preventDoubleClicks() {
		if (document.getElementsByClassName("prevent-double-click")) {
			for (i = 0; i < document.getElementsByClassName("prevent-double-click").length; i++) {
				document.getElementsByClassName("prevent-double-click")[i].style.pointerEvents = 'none';
			}
		}
	}

	var $form = $(`#${params.formId}`),
		imageForAddToModal = '',
		productTitleForAddToModal = 'asd',
		fromCYL,
		productName = '',
		productBrand = '',
		sharedWishlistData = '';

	if ($('.quickview-image').length > 0) {
		if ($('.dynamicModalContainer').hasClass('oss-modal')) fromCYL = true;
		$('body').css('top', '');
		imageForAddToModal = $('.dynamicModalContainer').find('.mainImage').eq(0).attr('src');
		productTitleForAddToModal = $('.dynamicModalContainer').find('.modal-title').last().text();
		productBrand = $('.dynamicModalContainer').find('.modal-title').first().text();
		productName = $('.dynamicModalContainer').find('.modal-title').last().text();
	} else if ($('.chanel-bundle').length > 0) {
		imageForAddToModal = $form.find('img').eq(0).attr('src');
		productTitleForAddToModal = `${$form.find('.chanel-title').html()}|${$form.find('.product-title').html()}|${$form.find('.product-subtitle').html()}`;
	} else if ($('.chanel-product').length > 0) {
		imageForAddToModal = $('.mainImage').attr('src');
		productTitleForAddToModal = `${$('.chanel-title').html()}|${$('.product-title').html()}|${$('.product-subtitle').html()}`;
	} else if ($('.chanel-product-item').length > 0) {
		imageForAddToModal = $form.find('img').eq(0).attr('src');
		productTitleForAddToModal = `${$('.chanel-title').eq(0).html()}|${$('.product-title').eq(0).html()}|${$('.product-subtitle').eq(0).html()}`;
	} else if ($('.product-bundle-page').length > 0) {
		imageForAddToModal = $form.parents('.list-item').find('.product-image').attr('src');
		productTitleForAddToModal = $form.parents('.list-item').find('.name').html();
	} else if ($('.product-grouping-display-page').length > 0) {
		if (params.formId == 'OrderItemAdd_0') {
			let bundleImg = !$('.desktopPage').length > 0 ? $('.mainProductImage .slick-active img') : $('.mainImage');
			imageForAddToModal = bundleImg.attr('src');
			productTitleForAddToModal = $('.product-title').html();
		} else {
			imageForAddToModal = $form.parents('.list-item').find('.product-image').attr('src');
			productTitleForAddToModal = $form.parents('.list-item').find('.name').html();
		}
	} else if ($('.product-item-display-page').length > 0) {
		imageForAddToModal = $form.find('.list-item').find('img').attr('src');
		productTitleForAddToModal = $('.product-title').html();
	} else if ($('.product-item-attr-page').length > 0) {
		imageForAddToModal = $form.find('.list-item').find('.product-image').attr('src');
		productTitleForAddToModal = $('.product-title').html();
	} else if ($('.outfit-display-page').length > 0) {
		imageForAddToModal = $form.parents('article').find('figure img').attr('src');
		productTitleForAddToModal = $form.parents('article').find('h1, h2').html();
	} else if ($('#wishListInShoppingBag').length > 0) {
		imageForAddToModal = $form
			.find('img')
			.eq(0)
			.attr('src')
			.split('DillardsZoom/wishList')
			.join('DillardsZoom/main')
			.split('DillardsZoom/productItem')
			.join('DillardsZoom/main');
		sharedWishlistData = $form.find('.oneClickOnly').attr('href').split('OrderItemAdd?')[1];
		if ($form.find('.chanel-shortDesc').length > 0) {
			productTitleForAddToModal = `${$('.chanel-brand-name').eq(0).html()}|${$('.chanel-product-name').eq(0).html()}|${$('.chanel-product-desc').eq(0).html()}`;
		}
	}

	////Build FIELD TWO
	if (params.formId != 'eCardForm') {
		let isMobilePage = $('.mobilePage').length > 0;
		let attrValPair = [];
		let attrName = '';
		let attrVal = '';
		if(!isMobilePage) {	
			let selectParent = document.querySelectorAll('#OrderItemAdd_qv .qvAttr');
			let attrStr = '';
			selectParent.forEach((item => {
				if(item) {
					let attrName = '';
					let attrVal = ''; 
					if(item.tagName === 'P') {
						attrName = item.getAttribute('data-attrname');
						attrName = attrName.charAt(0).toUpperCase() + attrName.slice(1);
						attrVal = item.getAttribute('data-attrvalue');;
					} else {
						attrName = item.getAttribute('data-attrname');
						attrName = attrName.charAt(0).toUpperCase() + attrName.slice(1);
						attrVal = item.value;
					}
					attrValPair.push(attrVal);

					if(attrStr.length != 0) {
						attrStr += '|';
					}
					attrStr += attrName + ':' + attrVal;
					}
				}	
				));
			if(attrStr) {
				document.querySelector('#FieldTwoForForm').value = attrStr;
			}
			attrValPair = attrValPair.sort();
			attrValPair = JSON.stringify(attrValPair);
	} else {
		let selectParent = document.querySelectorAll('#OrderItemAdd_qv .qvAttr');
		let attrStr = '';
		selectParent.forEach((item => {	
	
			if(item) {
				let attrName, attrVal, attrName_noSpace_LC;
				if(item.tagName === 'SELECT') {
					attrName = item.getAttribute('data-attrname');
					attrName = attrName.charAt(0).toUpperCase() + attrName.slice(1);
					attrVal = item.value;
				} else if(item.tagName === 'P') {
					attrName = item.getAttribute('data-attrname');
					attrName = attrName.charAt(0).toUpperCase() + attrName.slice(1);
					attrVal = item.innerHTML;
				} else {
					attrName = item.getAttribute('data-attrname');
					attrName_noSpace_LC = attrName.toLowerCase().replace(' ', '');
					attrName = attrName.charAt(0).toUpperCase() + attrName.slice(1);
					
					let selectFlat = document.querySelectorAll('.flat li');
					selectFlat.forEach((item => {
						let itemAttrName = item.getAttribute('data-attrname');

						if(item.classList.contains('size-selected') && itemAttrName === attrName_noSpace_LC) {
							attrVal = item.getAttribute('data-attrvalue');
						}
				}))

			}
			attrValPair.push(attrVal);
			if(attrStr.length != 0) {
				attrStr += '|';
			}
			attrStr += attrName + ':' + attrVal;
			}
	
		}	
		));
		if(attrStr) {
			document.querySelector('#FieldTwoForForm').value = attrStr;
		}
		attrValPair = attrValPair.sort();
		attrValPair = JSON.stringify(attrValPair);
	
	}	
		
		//GET MAIN SKU//
		
		let mainSKU = '';
		let getSKUS = JSON.parse(document.getElementById('allSkus').innerText);
		let skuNosVals = {};
		if(getSKUS.length == 1) {
			Object.values(getSKUS).map((oneSKU => {
				mainSKU = oneSKU.catentryId;
			}))
		} else {
			getSKUS?.map((sku, index) => {
				const catentryId = sku.catentryId;
				sku.definingAttributes.map((attr) => {
					const name = attr.name
					const catID = attr.catentryId;
					const value = attr.value.value
					if (skuNosVals[catentryId]) {
						skuNosVals[catentryId].values = [...(skuNosVals[catentryId].values || []),  value ]
					} else {
						skuNosVals[catentryId] = { catentryId }
						skuNosVals[catentryId].values = [ value ];
					}
				})
			})
			Object.values(skuNosVals).map((sku => {	
				let catID = sku.catentryId;
				let mainValPair = sku.values.sort();
				let mainValPairStr = JSON.stringify(mainValPair);
				if(mainValPairStr === attrValPair) {
					mainSKU = catID;
				}				
			}))
		}

		if(mainSKU) {
			document.querySelector('#catEntryIdSKU').value = mainSKU;
		}
	}
	
	if (dataLayer && dataLayer.page && dataLayer.page.primaryCategory && dataLayer.page.subCategory1 && dataLayer.page.subCategory2) {
		$(`#${params.formId}`).append(`<input type='hidden' name='primaryCategory' value='${(dataLayer.page.primaryCategory) ? dataLayer.page.primaryCategory.split('|').join('').trim() : ''}' id='primaryCategory' />`);
		$(`#${params.formId}`).append(`<input type='hidden' name='subCategory1' value='${dataLayer.page.subCategory1.split('|').join('').trim()}' id='subCategory1' />`);
		$(`#${params.formId}`).append(`<input type='hidden' name='subCategory2' value='${dataLayer.page.subCategory2.split('|').join('').trim()}' id='subCategory2' />`);
	}

	var personalizationTrackingParam = '',
		parentToLookForPersonalizationSuper = $('body');
	if ($('.quickview-image').length > 0) parentToLookForPersonalizationSuper = $('.modal-body');
	if (parentToLookForPersonalizationSuper.find('.personalizationsuperforpoints').length > 0)
		personalizationTrackingParam = `&superAddedFrom=${parentToLookForPersonalizationSuper.find('.personalizationsuperforpoints').eq(0).html()}`;
	addToBagPersonalizationTracking();
	var origCartQty = 0;
	if (dataLayer.cartInfo && dataLayer.cartInfo.items) {
		origCartQty = dataLayer.cartInfo.items * 1;
	}

	const url = '/webapp/wcs/stores/servlet/OrderItemAdd?' + ((dataLayer.product && dataLayer.product.isQuickView && dataLayer.product.isQuickView == 'Y') ? 'ak=y' : 'ak=n');
	const data = `${$(`#${params.formId}`).serialize()}${personalizationTrackingParam}${getPersonalizationMergeParameter()}${sharedWishlistData}`
	$.ajax({
		url: url,
		cache: false,
		type: 'POST',
		data: data,
		success: function (html) {
			if (html.search('AddToCartModalNotErrored') > 0) {
				// if (!$('.desktopPage').length > 0) {
				//   $('body').addClass('modal-special');
				//   $('body').css('top', setTop);
				// }
				returnHTML(html, myCallback);
				if (html.search('<strong>0</strong>') > 0) $('#ModalLabel').html('Item(s) not in stock.');
				$('.add-to-modal-image').attr('src', imageForAddToModal);
				if (productTitleForAddToModal.indexOf('|') > 0 && $('.chanel-add-to-modal-title > .chanel-brand-name > strong').length > 0) {
					$('.chanel-add-to-modal-title > .chanel-brand-name > strong').html(productTitleForAddToModal.split('|')[0]);
					$('.chanel-add-to-modal-title > .chanel-product-name > strong').html(productTitleForAddToModal.split('|')[1]);
					$('.chanel-add-to-modal-title > .chanel-product-desc').html(productTitleForAddToModal.split('|')[2]);
				} else $('.add-to-modal-title').html(productTitleForAddToModal);
				$('#FieldTwoForForm').remove();
				// If you are on the checkout page and the "CONTINUE SHOPPING" button is visible...
				var continueShoppingButton = $('.modal-left .checkoutContainer').find('a.forceCheckout');
				var comingSoonModal = $('.comingsoon_title');
				var checkoutHref = $('.modal-left .checkoutContainer').children('.btn-line:contains("Continue Shopping")').data('refresh');
				if ($('.checkout-pages').length > 0 && continueShoppingButton.length > 0 && $('.checkout-pages').length > 0 && comingSoonModal.length < 1) {
					// Remove the "x" button.
					if ($('#addToCartCheckOutButton').length > 0) {
						var checkoutHref = $('#addToCartCheckOutButton').attr('href'),
							continueShoppingShoppingCartX = $('.closeATB');
						continueShoppingShoppingCartX.attr('onClick', `location.href='${checkoutHref}';preventDoubleClicks();`);
					} else {
						continueShoppingButton.parents('.modal-content').find('.close').remove();
					}
					continueShoppingButton.remove();
				}
				//For Flat Sizes
				if ($('.size').length > 1) $('.product_info p.size:first').hide();

				if ($('.modal-title-ATB').length > 0 && $('.outOfStock').length == 0) {
					//Picks the phrase for Add To Bag
					var atbPhrases = ['We like your style!', "You've got great taste!", 'Excellent Choice!'];
					var atbNum = Math.floor(Math.random() * 3);
					var usePhrase = atbPhrases[atbNum];
					$('.modal-title-ATB').text(usePhrase);
				}

				//Intl Currency Convt
				if ($('.priceDisplayed').length > 0 && Cookies.get('zCountry') != 'US') {
					$('.priceDisplayed').html(quickConvert($('.priceDisplayed').html().split('$').join('')));
				}

				//Page refresh when clicking Continue Shopping btn only in shopping bag so user see's items have been added
				if ($('.checkout-pages').length > 0) {
					var continueShoppingShoppingCart = $('.modal-left .checkoutContainer').children('.btn-line:contains("Continue Shopping")');
					var continueShoppingShoppingCartX = $('.closeATB');
					continueShoppingShoppingCart.attr('href', checkoutHref);
					continueShoppingShoppingCart.removeAttr('data-dismiss');
					continueShoppingShoppingCart.removeAttr('data-target');
					continueShoppingShoppingCart.removeAttr('data-twist');
					//For X
					continueShoppingShoppingCartX.attr('onClick', `location.href='${checkoutHref}';preventDoubleClicks();`);
					continueShoppingShoppingCartX.removeAttr('data-dismiss');
					continueShoppingShoppingCartX.removeAttr('data-twist');
				}
				// Return to previous Complete Your Look modal
				if (fromCYL) {
					$('[data-twist="add-to-modal-continue-shopping"],[data-twist="continue-shopping-oh"]').on('click', function () {
						$('body').removeClass('modal-open');
						$(`#this-look-carousel a[data-modal-body*="${params.catentry}"]`).click();
					});
				}
				$('#dynamicModalContainer').on('hidden.bs.modal', function () {
					if (!$('.desktopPage').length > 0) qvClose_mt(pos);
				});
				try {
					var itemAddedInfoDiv = $('.addToBagData');
					dataLayer.itemAddedInfo = {
						childPartNumber: itemAddedInfoDiv.data('childpartnumber') + '',
						quantityAdded: (itemAddedInfoDiv.data('quantityadded') || '0') + '',
						priceAdded: itemAddedInfoDiv.data('priceadded') || '',
						quantityRequested: itemAddedInfoDiv.data('quantityrequested') || '',
					};
				} catch (e) { }
				try {
					dataLayer.itemAddedInfo.productBrand = productBrand;
					dataLayer.itemAddedInfo.productName = productName;
				} catch (e) { }
				try {
					dataLayer.itemAddedInfo.fullImage = imageForAddToModal.split('/')[$('.mainImage').attr('src').split('/').length - 1].split('.jpg').join('');
				} catch (e) { }

				try { $(document).trigger('addToCart'); } catch (e) { }

				try {
					try {
						if (origCartQty * 1 == 0) {
							dataLayer.commerce = { productListOpens: { value: 1 }, productListAdds: { value: 1 } };
						} else {
							dataLayer.commerce = { productListAdds: { value: 1 } };
						}
					} catch (e) {
						dataLayer.commerce = { productListAdds: { value: 1 } };
					}

					dataLayer.productListItems = [{
						SKU: dataLayer.product.partNumber
						, quantity: dataLayer.itemAddedInfo.quantityAdded
						, priceTotal: (Math.round(dataLayer.itemAddedInfo.priceAdded * 100) * dataLayer.itemAddedInfo.quantityAdded) / 100 || ''
						, name: (dataLayer.product && dataLayer.product.name) ? dataLayer.product.name.split('#double;').join('"').split('-').join(' ').replace(/[^a-zA-Z 0-9]/g, "") : ''
					}];

					if (dataLayer.itemAddedInfo.quantityAdded == ('' || 0 || undefined)) {
						dataLayer.flags = dataLayer.flags ? dataLayer.flags : {};
						dataLayer.flags.ItemNotAdded = 'Y';
						if (dataLayer.productListAdds.value != (0 || '' || undefined)) {
							dataLayer.productListAdds.value = (dataLayer.productListAdds.value - 1)
						}

					}
				} catch (e) { }
				return false;
			} else {
				$('#FieldTwoForForm').remove();
				var form = $('#' + params.formId);
				var isShopTheOutfit = $('.outfit-display-page').length > 0;
				var outfitShopperActions = form.parents('.shopper_action_wrapper');
				var isMobile = $('.mobilePage').length > 0;
				var isQV = $('.modal-quickview').length > 0;
				var shopperActions = form;
				var qvScroll = $('.modal-quickview .q-view-scroll');

				const removeExistingPopover = (container) => {
					container.find('.popover-wrapper').remove();
					container.find('.txt-error').remove();
				};

				if (isQV) {
					removeExistingPopover(qvScroll);
				} else if (isShopTheOutfit && !isMobile) {
					removeExistingPopover(outfitShopperActions);
				} else {
					removeExistingPopover(shopperActions);
				}

				var addToBagError = '<div class="errorAddingToBag hidden">Error Adding to cart: ' + html + '</div>';

				var popoverTemplate =
					'<div class="popover-wrapper"><div class="popover-error" role="tooltip"><div class="popover-content-error" role="status" aria-live="polite">There was an error adding this item to your bag. Please try again later.</div></div></div>';

				$('.errorAddingToBag').remove();
				if (isQV) {
					$(popoverTemplate).insertAfter('.modal-quickview .product-select-boxes');
					$(addToBagError).insertAfter('.modal-quickview .product-select-boxes');
				} else if (isShopTheOutfit && !isMobile) {
					$(popoverTemplate).insertAfter('.outfit-display-page .product-select-boxes');
					$(addToBagError).insertAfter('.outfit-display-page .product-select-boxes');
				} else {
					$(popoverTemplate).insertBefore(shopperActions.find('.shopper-actions'));
					$(addToBagError).insertBefore(shopperActions.find('.shopper-actions'));
				}

				//        form.attr("action", "/webapp/wcs/stores/servlet/OrderItemAdd");
				//        form.submit();
			}
		},
		error: function (jqXHR, textStatus, errorThrown) {
			if (jqXHR.status === 428 && window.ak_chlge) {
				const responseJSON = JSON.parse(jqXHR.responseText)
				window.ak_chlge.showChallenge(responseJSON, url + '?' + data); //start the challenge workflow on UI
			}
			if ($('#wishListInShoppingBag').length > 0) {
				window.location = '/webapp/wcs/stores/servlet/OrderItemAdd?' + sharedWishlistData;
			}
		},
	});
};
